import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const ZodCurrencyInputTransformation = () => {
  const { t } = useTranslation('common');
  return z
    .string()
    .nonempty({ message: t('mandatoryCurrencyValue') })
    .or(z.number().min(0))
    .transform(val =>
      typeof val === 'string'
        ? Number(
            val
              .replace(/\./g, '')
              .replace(/,/, '.')
              .replace(/R\$/, '')
              .replace(/%/g, ''),
          )
        : val,
    );
};

export const zodCurrencyInputTransformationOptional = z
  .string()
  .or(z.number())
  .optional()
  .transform(val =>
    typeof val === 'string'
      ? Number(
          val
            .replace(/\./g, '')
            .replace(/,/, '.')
            .replace(/R\$/, '')
            .replace(/%/g, ''),
        )
      : val,
  );
